import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuthStore } from './store/authStore'
import Login from './pages/Login'
import EventosList from './pages/EventosList'
import EventoDetail from './pages/EventoDetail'
import Layout from './components/layout/Layout'

function App() {
  const { isAuthenticated } = useAuthStore()

  return (
    <BrowserRouter
      future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true,
      }}
    >
      <Routes>
        {/* Ruta de login */}
        <Route
          path="/login"
          element={isAuthenticated ? <Navigate to="/eventos" replace /> : <Login />}
        />

        {/* Rutas protegidas */}
        <Route
          path="/"
          element={isAuthenticated ? <Layout /> : <Navigate to="/login" replace />}
        >
          <Route index element={<Navigate to="/eventos" replace />} />
          <Route path="eventos" element={<EventosList />} />
          <Route path="eventos/:id" element={<EventoDetail />} />
        </Route>

        {/* Ruta 404 */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
